
export default function RoutesDiagramExactReactUI() {
  
  return (
<div className="w-full overflow-hidden bg-white text-slate-800">
<div className="mx-auto w-full max-w-[1520px] px-3 pb-0 pt-0 sm:px-6 lg:px-8">
  <div className="relative mx-auto w-full max-w-[1500px] rounded-b-[34px] bg-gradient-to-b from-[#f1f7ff] via-white to-white px-4 pb-8 pt-8 sm:px-10 lg:px-16">
          {/* decorative accent lines, top corners */}
          {/* <div className="pointer-events-none absolute left-0 top-[152px] hidden sm:block h-[2px] w-[190px] bg-gradient-to-r from-[#c9f26b] to-[#5fd3c4] rounded-full opacity-90" />
          <div className="pointer-events-none absolute right-0 top-[152px] hidden sm:block h-[2px] w-[95px] bg-gradient-to-l from-[#5fd3c4] to-[#c9f26b] rounded-full opacity-90" /> */}

          <div className="text-center max-w-[900px] mx-auto">
            <h1 className="text-[26px] sm:text-[33px] lg:text-[36px] font-semibold tracking-[-0.03em] leading-[1.15] text-[#2F5E9B]">
              Discover Private Day Trips from Salzburg
            </h1>
            <p className="mt-4 text-[16px] sm:text-[18px] lg:text-[20px] leading-[1.45] text-[#6E6E73] font-normal max-w-[780px] mx-auto">
              Explore Austria&apos;s most beautiful destinations with a private driver,
              comfortable vehicle and flexible itinerary.
            </p>
          </div>

       </div>
      </div>
    </div>
  )
}
